export default __webpack_public_path__ + "static/media/theride.f616abdb.png";